import type LeftNavGroupsSchema from './schema/LeftNavGroups';
import { createStore } from 'satcheljs';
import type GroupNodeViewState from './schema/GroupNodeViewState';
import { ObservableMap } from 'mobx';

const defaultLeftNavGroupsStore: LeftNavGroupsSchema = {
    myOrgGroups: [],
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (11,5): Type 'null' is not assignable to type 'LeftNavGroupsContextMenuSchema'.
    // @ts-expect-error
    withContextMenuGroup: null,
    shouldShowAllGroups: false,
    hasLoadedFromServer: false,
    loadGroupsError: false,
    groupNodeViewStates: new ObservableMap<string, GroupNodeViewState>({}),
};

const leftNavGroupsStore = createStore<LeftNavGroupsSchema>(
    'leftNavGroupsStore',
    defaultLeftNavGroupsStore
)();
export default leftNavGroupsStore;
export const getLeftNavGroupsStore = () => leftNavGroupsStore;
